<template>
    <div class='text-element' :style='[element.element_config.compiled_styles, custom_styles.text]' :class='[classes.text]' v-html='element.element_config.config.text'>

    </div>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['element', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            classes: {}
        }
    },
    methods:{
        setClasses(){
            if(this.element.element_config.compiled_classes != null){
                this.classes = this.element.element_config.compiled_classes;
            }
        }
    },
    watch:{
        'element': {
            handler(){
                this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
                this.setClasses();
            },
            deep: true
        }
    },
    mounted(){
        this.setCustomCssStyles(this.element.element_config.custom_styles); //From mixin
        this.setClasses();
    }

}
</script>

<style lang="scss" scoped>
.text-element{
    width: 100%;
}

.empty-space-text{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 1.2rem;
    color: #385170;
}
</style>